/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useCallback } from 'react';
import { useDesktopActions } from '../DesktopContext';

export type SettingsTabId = 'appearance' | 'dock' | 'apps' | 'agent';

/**
 * Opens Settings at a tab. An open Settings window switches its current tab and comes to the
 * front, instead of `openPath` adding another tab every time ⌘, is pressed.
 */
export const useOpenSettings = () => {
  const { getDesktopState, dispatchDesktop, openPath } = useDesktopActions();
  return useCallback(
    (tab: SettingsTabId = 'appearance') => {
      const path = `/settings/${tab}`;
      const settingsWindow = getDesktopState().windows.find(
        (windowState) => windowState.appId === 'settings' && windowState.isOpen,
      );
      if (!settingsWindow) {
        openPath(path);
        return;
      }
      dispatchDesktop({ type: 'navigate', id: settingsWindow.id, path, replace: true });
      dispatchDesktop({ type: 'open', id: settingsWindow.id });
    },
    [getDesktopState, dispatchDesktop, openPath],
  );
};
